import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHeader, Spinner, LinkButton } from "@/components/site/kit";
import { Reveal } from "@/components/motion/primitives";
import { getProject } from "@/lib/api";
import { ArrowLeft, ExternalLink, ArrowUpRight } from "lucide-react";

export default function ProjectDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => { setP(null); getProject(id).then(setP).catch(() => setNotFound(true)); }, [id]);

  if (notFound) return <div className="pt-40 pb-40 text-center"><p className="font-display text-4xl">Project not found.</p><Link to="/projects" className="text-primary mt-4 inline-block link-underline">Back</Link></div>;
  if (!p) return <div className="pt-24"><Spinner /></div>;

  return (
    <div data-testid="project-detail-page">
      <PageHeader chapter={`Project / ${p.status}`} titleLines={[p.name]} description={p.tagline} />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <Reveal>
            <div className="aspect-[16/9] overflow-hidden border border-border mb-12">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <div className="grid lg:grid-cols-12 gap-12">
            <Reveal className="lg:col-span-8">
              <p className="text-xl md:text-2xl leading-relaxed">{p.description}</p>
            </Reveal>
            <div className="lg:col-span-4 space-y-8">
              <Reveal>
                <p className="overline text-primary mb-4">Focus Areas</p>
                <div className="flex flex-wrap gap-2">{(p.tags || []).map((t) => <span key={t} className="font-mono text-xs border border-border px-3 py-1.5">{t}</span>)}</div>
              </Reveal>
              {p.url && (
                <Reveal>
                  <a href={p.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-border px-6 py-3 hover:border-primary hover:text-primary transition">Visit Project <ExternalLink className="w-4 h-4" /></a>
                </Reveal>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 bg-secondary/20 border-y border-border text-center">
        <h2 className="font-display text-4xl md:text-6xl mb-8 px-5">Interested in collaborating?</h2>
        <LinkButton to="/contact" primary>Reach out <ArrowUpRight className="w-5 h-5" /></LinkButton>
      </section>
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-12">
        <Link to="/projects" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary"><ArrowLeft className="w-4 h-4" /> All Projects</Link>
      </div>
    </div>
  );
}
